module.exports = __webpack_public_path__ + "static/agentshop-985781adb40006b8dab3d9d72692a184.png";